import type { ConceptDef } from '../types';

export const imitateWithObjects: ConceptDef = {
  kind: 'supervisorScored',
  id: 'imitate-with-objects',
  label: 'Imitate With Objects',
  category: 'Motor imitation',
  description: 'Model an action with an object; learner imitates. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Stack two blocks.' },
      { prompt: 'Roll the ball.' },
      { prompt: 'Spin the top.' },
      { prompt: 'Pour from one cup to another.' },
      { prompt: 'Tap the drum twice.' },
    ],
  },
};
